"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProviderLocations_1 = __importDefault(require("./ProviderLocations"));
exports.default = ProviderLocations_1.default;
//# sourceMappingURL=index.js.map